// @ts-nocheck
(function () {
  'use strict';

  // $49.990 CLP en subunidades Shopify (siempre x100)
  var FREE_SHIP = 49990 * 100;

  // Variant IDs de las 4 Cajas de 20 (un producto por sabor, sin tag/tipo común
  // para detectarlas). Fuente: tema/templates/product.bundle-pack40.json
  var CAJA20_FLAVORS = {
    '49195419336997': 'Maní',
    '49195418812709': 'Cacao',
    '51994453213477': 'Chocolate Blanco',
    '51994461634853': 'Caramelo',
  };

  // Variant IDs de las 4 Cajas de 5. Desde 4 cajas (cualquier combinación de
  // sabores) el envío va al 50%, lo aplica Amplifica en el checkout.
  // Fuente: tema/templates/product.caja5.json
  var CAJA5_VARIANTS = [
    '47267878568229', // Maní
    '47267878600997', // Cacao
    '52059554939173', // Chocolate Blanco
    '52059551138085', // Caramelo
  ];
  var CAJA5_MIN_ENVIO_50 = 4;

  function contarCaja5(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (CAJA5_VARIANTS.indexOf(String(cart.items[i].variant_id)) !== -1) {
        n += cart.items[i].quantity;
      }
    }
    return n;
  }

  function fmt(shopifyPrice) {
    return '$' + Math.round(shopifyPrice / 100).toLocaleString('es-CL');
  }

  var EpCartDrawer = {
    _busy: false,
    _caja20UpsellKey: null,
    _caja20CurrentVariantId: null,
    _caja20SelectedVariant: null,
    _caja20ImageCache: {},

    init: function () {
      this.drawer  = document.getElementById('ep-cart-drawer');
      this.overlay = document.getElementById('ep-cart-drawer-overlay');
      if (!this.drawer) return;

      this.overlay.addEventListener('click', this.close.bind(this));
      this.drawer.querySelector('.ep-cart-drawer__close').addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') EpCartDrawer.close();
      });

      // Delegación de eventos en la lista de items
      document.getElementById('ep-cart-items').addEventListener('click', function (e) {
        if (EpCartDrawer._busy) return;
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var itemEl = btn.closest('[data-key]');
        if (!itemEl) return;
        var key = itemEl.dataset.key;
        var action = btn.dataset.action;

        if (action === 'remove') {
          EpCartDrawer.setQty(key, 0, itemEl);
        } else if (action === 'plus') {
          var current = parseInt(itemEl.querySelector('.ep-cart-item__qty').textContent, 10);
          EpCartDrawer.setQty(key, current + 1, itemEl);
        } else if (action === 'minus') {
          var current = parseInt(itemEl.querySelector('.ep-cart-item__qty').textContent, 10);
          EpCartDrawer.setQty(key, Math.max(0, current - 1), itemEl);
        }
      });

      // Swatches de sabor del upsell: eligen qué variante se agrega, sin agregar todavía
      var caja20Swatches = document.getElementById('ep-caja20-swatches');
      if (caja20Swatches) {
        caja20Swatches.addEventListener('click', function (e) {
          var swatch = e.target.closest('[data-variant-id]');
          if (!swatch) return;
          EpCartDrawer._caja20SelectedVariant = swatch.dataset.variantId;
          var all = caja20Swatches.querySelectorAll('[data-variant-id]');
          for (var i = 0; i < all.length; i++) {
            all[i].classList.toggle('ep-cart-drawer__caja20-swatch--selected', all[i] === swatch);
          }
          document.getElementById('ep-caja20-upsell-flavor').textContent = ' ' + swatch.dataset.flavor;
          EpCartDrawer.loadCaja20Image(swatch.dataset.handle, swatch.dataset.flavor);
        });
      }

      // Botón "Agregar" del upsell de segunda Caja de 20
      var caja20Btn = document.getElementById('ep-caja20-upsell-btn');
      if (caja20Btn) {
        caja20Btn.addEventListener('click', function () {
          if (EpCartDrawer._busy || !EpCartDrawer._caja20UpsellKey) return;
          caja20Btn.disabled = true;
          if (EpCartDrawer._caja20SelectedVariant === EpCartDrawer._caja20CurrentVariantId) {
            EpCartDrawer.setQty(EpCartDrawer._caja20UpsellKey, 2, null);
          } else {
            EpCartDrawer.addVariant(EpCartDrawer._caja20SelectedVariant);
          }
        });
      }

      // Interceptar el ícono del carrito nativo de Shopify.
      // Funciona tanto si el tema usa cart_type=drawer (Web Component) como
      // si usa el link directo a /cart. La fase de captura (true) garantiza
      // que corremos antes de que cualquier handler nativo de Shopify procese
      // el click, evitando que se abran ambos carritos al mismo tiempo.
      var self = this;
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[aria-describedby="cart-bubble-text"]');
        if (!trigger) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.open();
      }, true);

      window.EpCartDrawer = this;
    },

    open: function () {
      document.body.style.overflow = 'hidden';
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this._showLoading(true);
      this.refresh();
    },

    close: function () {
      document.body.style.overflow = '';
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
    },

    refresh: function () {
      var self = this;
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { self._showLoading(false); });
    },

    setQty: function (key, qty, itemEl) {
      var self = this;
      this._busy = true;
      if (itemEl) itemEl.classList.add('ep-cart-item--loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._busy = false;
          self.render(cart);
        })
        .catch(function () {
          self._busy = false;
          if (itemEl) itemEl.classList.remove('ep-cart-item--loading');
        });
    },

    addVariant: function (variantId) {
      var self = this;
      this._busy = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self._busy = false;
          self.render(cart);
        })
        .catch(function () {
          self._busy = false;
        });
    },

    loadCaja20Image: function (handle, flavor) {
      var imgEl = document.getElementById('ep-caja20-upsell-img');
      if (!imgEl || !handle) return;

      if (this._caja20ImageCache[handle]) {
        imgEl.src = this._caja20ImageCache[handle];
        imgEl.alt = flavor;
        return;
      }

      var self = this;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var url = product.featured_image;
          if (!url) return;
          url = url.replace(/(\.\w+)(\?|$)/, '_100x100$1$2');
          self._caja20ImageCache[handle] = url;
          imgEl.src = url;
          imgEl.alt = flavor;
        })
        .catch(function () {});
    },

    _showLoading: function (show) {
      var loadingEl  = document.getElementById('ep-cart-loading');
      var itemsEl    = document.getElementById('ep-cart-items');
      var emptyEl    = document.getElementById('ep-cart-empty');
      var footerEl   = document.getElementById('ep-cart-footer');
      if (show) {
        loadingEl.removeAttribute('hidden');
        itemsEl.innerHTML = '';
        emptyEl.setAttribute('hidden', '');
        footerEl.setAttribute('hidden', '');
      } else {
        loadingEl.setAttribute('hidden', '');
      }
    },

    render: function (cart) {
      this._showLoading(false);

      var progressWrap = document.getElementById('ep-cart-progress-wrap');
      var progressMsg  = document.getElementById('ep-cart-progress-msg');
      var progressFill = document.getElementById('ep-cart-progress-fill');
      var itemsEl      = document.getElementById('ep-cart-items');
      var emptyEl      = document.getElementById('ep-cart-empty');
      var footerEl     = document.getElementById('ep-cart-footer');
      var savingsEl    = document.getElementById('ep-cart-savings');
      var savingsAmt   = document.getElementById('ep-cart-savings-amt');
      var subtotalEl   = document.getElementById('ep-cart-subtotal');

      var total = cart.total_price;
      var isEmpty = cart.item_count === 0;

      // Barra de progreso
      var pct = Math.min(100, Math.round((total / FREE_SHIP) * 100));
      progressFill.style.width = pct + '%';

      if (isEmpty) {
        progressWrap.setAttribute('hidden', '');
      } else {
        progressWrap.removeAttribute('hidden');
      }

      if (total >= FREE_SHIP) {
        progressMsg.innerHTML = '¡Tienes <strong>envío gratis</strong> en tu pedido! 🎉';
        progressFill.classList.add('is-done');
      } else {
        var falta = fmt(FREE_SHIP - total);
        progressMsg.innerHTML = 'Te faltan <strong>' + falta + '</strong> para <strong>envío gratis 🚚</strong>';
        progressFill.classList.remove('is-done');
      }

      if (isEmpty) {
        itemsEl.innerHTML = '';
        emptyEl.removeAttribute('hidden');
        footerEl.setAttribute('hidden', '');
        return;
      }

      emptyEl.setAttribute('hidden', '');
      footerEl.removeAttribute('hidden');

      // Render items
      itemsEl.innerHTML = cart.items.map(function (item) {
        return EpCartDrawer.renderItem(item);
      }).join('');

      // Upsell: agregar una segunda Caja de 20 (mismo sabor).
      // Solo aparece con exactamente 1 línea en el carrito, esa línea es una
      // Caja de 20 y su cantidad es 1. Si ya hay 2+ o hay otro producto, se oculta.
      var caja20Upsell = document.getElementById('ep-cart-caja20-upsell');
      if (caja20Upsell) {
        var showCaja20Upsell = false;
        if (cart.items.length === 1) {
          var onlyItem = cart.items[0];
          var flavor = CAJA20_FLAVORS[String(onlyItem.variant_id)];
          if (flavor && onlyItem.quantity === 1) {
            showCaja20Upsell = true;
            this._caja20UpsellKey = onlyItem.key;
            document.getElementById('ep-caja20-upsell-flavor').textContent = ' ' + flavor;
            var caja20Img = document.getElementById('ep-caja20-upsell-img');
            if (onlyItem.image) {
              caja20Img.src = onlyItem.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2');
              caja20Img.alt = onlyItem.product_title;
            }
          }
        }
        if (showCaja20Upsell) {
          caja20Upsell.removeAttribute('hidden');
          document.getElementById('ep-caja20-upsell-btn').disabled = false;

          // Reset: la selección de sabor vuelve a coincidir con lo que ya hay en el carrito
          var currentVariantId = String(onlyItem.variant_id);
          this._caja20CurrentVariantId = currentVariantId;
          this._caja20SelectedVariant = currentVariantId;
          var swatchBtns = document.querySelectorAll('#ep-caja20-swatches [data-variant-id]');
          for (var i = 0; i < swatchBtns.length; i++) {
            swatchBtns[i].classList.toggle('ep-cart-drawer__caja20-swatch--selected', swatchBtns[i].dataset.variantId === currentVariantId);
          }
        } else {
          caja20Upsell.setAttribute('hidden', '');
          this._caja20UpsellKey = null;
          this._caja20CurrentVariantId = null;
          this._caja20SelectedVariant = null;
        }
      }

      // Ahorro
      if (cart.total_discount > 0) {
        savingsAmt.textContent = fmt(cart.total_discount);
        savingsEl.removeAttribute('hidden');
      } else {
        savingsEl.setAttribute('hidden', '');
      }

      // Envío gratis ganado (mismo umbral que la barra de progreso)
      var tieneEnvioGratis = total >= FREE_SHIP;
      var shippingEarnedEl = document.getElementById('ep-cart-shipping-earned');
      if (shippingEarnedEl) {
        if (tieneEnvioGratis) {
          shippingEarnedEl.removeAttribute('hidden');
        } else {
          shippingEarnedEl.setAttribute('hidden', '');
        }
      }

      // Envío al 50% desde 4 Cajas de 5. Si ya ganó el envío gratis no se
      // muestra, porque gratis es mejor que la mitad y confundiría.
      var shippingHalfEl = document.getElementById('ep-cart-shipping-half');
      if (shippingHalfEl) {
        if (!tieneEnvioGratis && contarCaja5(cart) >= CAJA5_MIN_ENVIO_50) {
          shippingHalfEl.removeAttribute('hidden');
        } else {
          shippingHalfEl.setAttribute('hidden', '');
        }
      }

      // Subtotal
      subtotalEl.textContent = fmt(total);
    },

    renderItem: function (item) {
      var imgUrl = '';
      if (item.image) {
        imgUrl = item.image.replace(/(\.\w+)(\?|$)/, '_100x100$1$2');
      }

      var imgHtml = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + escHtml(item.product_title) + '" class="ep-cart-item__img" loading="lazy">'
        : '<div class="ep-cart-item__img-ph"></div>';

      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="ep-cart-item__variant">' + escHtml(item.variant_title) + '</p>'
        : '';

      var priceHtml;
      if (item.original_line_price > item.final_line_price) {
        priceHtml = '<span class="ep-cart-item__price ep-cart-item__price--sale">' + fmt(item.final_line_price) + '</span>'
          + '<span class="ep-cart-item__price ep-cart-item__price--original">' + fmt(item.original_line_price) + '</span>';
      } else {
        priceHtml = '<span class="ep-cart-item__price">' + fmt(item.final_line_price) + '</span>';
      }

      var minusDisabled = item.quantity <= 1 ? ' disabled' : '';

      return '<div class="ep-cart-item" data-key="' + escHtml(item.key) + '">'
        + '  <a href="' + escHtml(item.url) + '" class="ep-cart-item__img-wrap">' + imgHtml + '</a>'
        + '  <div class="ep-cart-item__info">'
        + '    <a href="' + escHtml(item.url) + '" class="ep-cart-item__title">' + escHtml(item.product_title) + '</a>'
        + variantTitle
        + '    <div class="ep-cart-item__bottom">'
        + '      <div class="ep-cart-item__qty-controls">'
        + '        <button type="button" data-action="minus"' + minusDisabled + ' aria-label="Restar">−</button>'
        + '        <span class="ep-cart-item__qty">' + item.quantity + '</span>'
        + '        <button type="button" data-action="plus" aria-label="Sumar">+</button>'
        + '      </div>'
        + '      <div class="ep-cart-item__prices">' + priceHtml + '</div>'
        + '    </div>'
        + '    <button type="button" class="ep-cart-item__remove" data-action="remove">Eliminar</button>'
        + '  </div>'
        + '</div>';
    },
  };

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    EpCartDrawer.init();
  });

  // Disable Shopify's default cart drawer completely
  document.addEventListener('DOMContentLoaded', function () {
    var shopifyDrawer = document.querySelector('cart-drawer-component');
    if (shopifyDrawer) {
      shopifyDrawer.showDialog = function () {};
      shopifyDrawer.openDialog = function () {};
      shopifyDrawer.open = function () {};

      var shopifyDialog = shopifyDrawer.querySelector('dialog');
      if (shopifyDialog) {
        new MutationObserver(function () {
          if (shopifyDialog.open) {
            shopifyDialog.close();
          }
        }).observe(shopifyDialog, { attributes: true, attributeFilter: ['open'] });
      }
    }
  });

  // Intercept clicks on the cart trigger and /cart links → open EP drawer
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-testid="cart-drawer-trigger"], a[href="/cart"], a[href="/cart/"]');
    if (!trigger) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (window.EpCartDrawer) {
      window.EpCartDrawer.open();
    }
  }, true);
})();
